// Other stuff
import { activateTracking } from './lib/tracking.js'
import activateSticky from './lib/sticky.js'
import 'instant.page'
import 'lazysizes'

import './components/block-links.js'
import './components/cart.js'
import './components/tabs.js'
import './components/navigation.js'
import './components/quantity-input.js'
import './components/star-input.js'
import './components/modal.js'
import './search/header-autocomplete.js'
import './search/results-page.js'
import './components/notification-bar.js'
import './components/announcement-banner.js'
import './components/lazy-video.js'
import './components/table-of-contents.js'
import './components/formie-error-handler.js'
import './components/product-gallery.js'
import './components/product-image-gallery.js'
import './lib/csrf-form-protection.js'

// GCLID utilities
import { captureGclidFromUrl } from './lib/gclid.js'
import { setupFormieGclidInjection } from './lib/formie-gclid.js'
import './lib/checkout-gclid.js'
import { getSearchClient } from './search/client.js'
import { initSearchInsights } from './search/insights.js'

/*
 * Activate Utilities
 */
activateTracking()
activateSticky()

// GCLID capture and injection (runs on every page load)
captureGclidFromUrl()
setupFormieGclidInjection()

// Prepare the shared client only when the Algolia provider is selected.
getSearchClient()
initSearchInsights()
